import { render, staticRenderFns } from "./TrackDetail.vue?vue&type=template&id=18f4ddb3&"
import script from "./TrackDetail.vue?vue&type=script&lang=js&"
export * from "./TrackDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrackDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports